// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Montenegro */
const ME = /^(?:6(?:[07-9]\d|3[024]|6[0-25])\d{5})$/;

export default ME;
